// extracted by css-extract-rspack-plugin
export default {"arrowIcon":"product-detail-fragment__RedemptionInfoBanner_arrowIcon__nrxzn"};